(function($) {

	$.fn.msxidatatable = function(options) {
		var this_ = this;
		if (this.length > 0) {
            initLanguageDataTableUrl(function (languageDataTableUrl) {
                initPlugin(this_, options, languageDataTableUrl);
            });
        }

        return this;
	};

	function initPlugin(this_, options, languageDataTableUrl) {
        $.fn.msxidatatable.defaults.oLanguage.sUrl = languageDataTableUrl;

        // build main options before element iteration
        var opts = $.extend( {}, $.fn.msxidatatable.defaults, options);

        this_.each(function() {
            var $datatable = $(this);
            // build element specific options
            var eOpts = $.fn.dataset ? $.extend( {}, opts, $datatable.dataset()) : opts;

            if($datatable.hasClass('sortable-table')) {
                eOpts['bSort'] = true;
                if(eOpts['sortList']) {
                    eOpts['aaSorting'] = eOpts['sortList'];
                }
            }
            if($datatable.hasClass('paged-table')) {
                eOpts['bPaginate'] = true;
                eOpts = $.extend({}, eOpts, {
                    'bLengthChange': true,
                    'bInfo': true,
                    'bAutoWidth': true,
                    'iDisplayLength': 25
                });
            }
            if($datatable.hasClass('filtered-table')) {
                eOpts['bFilter'] = true;
            }

			// Apply metadata overrides last as can be used to configure iDisplayLength
            eOpts = $.metadata ? $.extend( {}, eOpts, $datatable.metadata()) : eOpts;
            $datatable.dataTable(eOpts);
        });
	}
	//
	// plugin defaults
	//
    $.fn.msxidatatable.defaults = {
        "bPaginate": false, /* Enable pagination */
		"bLengthChange": false, /* Change records per page (drop down) */
		"bFilter": false, /* Enable filtering (Search box) */
		"bSort": false, /* Enable sorting */
		"bInfo": false, /* Show record counts */
		"bAutoWidth": false, /* fix column widths for pagination */
        "sPaginationType": "full_numbers_msxi", /* function to generate pagination */
        'bStateSave': true, /* save page, filter and sort state in cookie */
        'sDom': '<"panel-legend"lfr>tip', /* layout of data table */
        "oLanguage": {
            "sUrl": staticJavaScriptUrl('/jquery/i18n/jquery.dataTables-en.json')
        }, /* language file (should be overridden by initLanguageDataTableUrl) */
        "fnInitComplete": function() {
            var $datatable = $(this);
            var oSettings = $datatable.dataTable().fnSettings();

            if(oSettings.oFeatures.bFilter)
            {
                initInputFilters($datatable, oSettings);
                initSelectFilters($datatable, oSettings);
                initNumericRangeFilters($datatable, oSettings);
                initHtmlOnlyFilters($datatable, oSettings);
                $datatable.find('tr.filters [placeholder]').msxiplaceholder();
            }

            $('.paging_full_numbers_msxi a.button').msxibutton();
            $datatable.find('.panel:not(.tabs),.tabs > .panel-content').msxiPanel();
        },
        "fnDrawCallback": function( oSettings ) {
            var $datatable = $(this);
            // Reset the column widths so that the trimmer calculates the column spacing according to the content on the page
            $datatable.data('expanded', false);
            $datatable.find('col').width('auto');
            $datatable.filter('table:has(col.trim):visible').msxiTableTrimmer();
        },
        "fnFooterCallback": function ( nRow, aaData, iStart, iEnd, aiDisplay ) {
            var $datatable = $(this);
            var oSettings = $datatable.dataTable().fnSettings();

            $datatable.find("col.aggregate-avg").each(function()
            {
                var columnIndex = $datatable.find("col").index($(this));

                var total = 0;
                var count = 0;
                for ( var i=0 ; i<aiDisplay.length ; i++ )
                {
                    var sData = $.fn.dataTableExt.ofnSearch[oSettings.aoColumns[columnIndex].sType]( aaData[ aiDisplay[i]][columnIndex] );
                    if(sData !== '') {
                        count++;
                    }
                    total += sData*1.0;
                }
                var avg = (count == 0 ? 0.0 : total/count).toFixed(2);

                addAggregateToFooter($datatable, oSettings, columnIndex, avg);
            });

            $datatable.find("col.aggregate-sum").each(function()
            {
                var columnIndex = $datatable.find("col").index($(this));

                var total = 0;
                for ( var i=0 ; i<aiDisplay.length ; i++ )
                {
                    var sData = $.fn.dataTableExt.ofnSearch[oSettings.aoColumns[columnIndex].sType]( aaData[ aiDisplay[i]][columnIndex] );
                    total += sData*1.0;
                }
                var sum = total.toFixed(2);

                addAggregateToFooter($datatable, oSettings, columnIndex, sum);
            });
		}
    };


	//
	// Custom classes
	//
    $.extend( $.fn.dataTableExt.oStdClasses, {
        "sPageButton": "paginate_button iterator-link",
		"sPageButtonActive": "paginate_active iterator-link current-page",
		"sPageButtonStaticDisabled": "paginate_button",
		"sPageFirst": "first button {icon:'ui-icon-triangle-1-w'}",
		"sPagePrevious": "previous button {icon:'ui-icon-triangle-1-w'}",
		"sPageNext": "next button {'secondary-icon':'ui-icon-triangle-1-e'}",
		"sPageLast": "last button {'secondary-icon':'ui-icon-triangle-1-e'}",
		"sPageList": "pages",
        "sPaging": "dataTables_paginate page-navigation paging_" /* Note that the type is postfixed */
    });


	//
	// Custom pagination
	//
    $.extend( $.fn.dataTableExt.oPagination, {
		/*
		 * Variable: full_numbers
		 * Purpose:  Full numbers pagination. Slightly different to allow styling buttons
	 	 * Scope:    jQuery.fn.dataTableExt.oPagination
		 */
		"full_numbers_msxi": {
			/*
			 * Function: oPagination.full_numbers.fnInit
			 * Purpose:  Initalise dom elements required for pagination with a list of the pages
			 * Returns:  -
	 		 * Inputs:   object:oSettings - dataTables settings object
	     *           node:nPaging - the DIV which contains this pagination control
			 *           function:fnCallbackDraw - draw function which must be called on update
			 */
			"fnInit": function ( oSettings, nPaging, fnCallbackDraw )
			{
				var nFirst = document.createElement( 'a' );
				var nPrevious = document.createElement( 'a' );
				var nList = document.createElement( 'div' );
				var nNext = document.createElement( 'a' );
				var nLast = document.createElement( 'a' );

				nFirst.innerHTML = oSettings.oLanguage.oPaginate.sFirst;
				nPrevious.innerHTML = oSettings.oLanguage.oPaginate.sPrevious;
				nNext.innerHTML = oSettings.oLanguage.oPaginate.sNext;
				nLast.innerHTML = oSettings.oLanguage.oPaginate.sLast;

				var oClasses = oSettings.oClasses;
				nFirst.className = oClasses.sPageButton+" "+oClasses.sPageFirst;
				nPrevious.className = oClasses.sPageButton+" "+oClasses.sPagePrevious;
				nNext.className= oClasses.sPageButton+" "+oClasses.sPageNext;
				nLast.className = oClasses.sPageButton+" "+oClasses.sPageLast;
				nList.className = oClasses.sPageList;

				nPaging.appendChild( nFirst );
				nPaging.appendChild( nPrevious );
                nPaging.appendChild( nLast );
                nPaging.appendChild( nNext );
                nPaging.appendChild( nList );

				$(nFirst).click( function () {
					if ( oSettings.oApi._fnPageChange( oSettings, "first" ) )
					{
						fnCallbackDraw( oSettings );
					}
				} );

				$(nPrevious).click( function() {
					if ( oSettings.oApi._fnPageChange( oSettings, "previous" ) )
					{
						fnCallbackDraw( oSettings );
					}
				} );

				$(nNext).click( function() {
					if ( oSettings.oApi._fnPageChange( oSettings, "next" ) )
					{
						fnCallbackDraw( oSettings );
					}
				} );

				$(nLast).click( function() {
					if ( oSettings.oApi._fnPageChange( oSettings, "last" ) )
					{
						fnCallbackDraw( oSettings );
					}
				} );

				/* Take the brutal approach to cancelling text selection */
				$('.iterator-link, .button', nPaging)
					.bind( 'mousedown', function () { return false; } )
					.bind( 'selectstart', function () { return false; } );

				/* ID the first elements only */
				if ( oSettings.sTableId !== '' && typeof oSettings.aanFeatures.p == "undefined" )
				{
					nPaging.setAttribute( 'id', oSettings.sTableId+'_paginate' );
					nFirst.setAttribute( 'id', oSettings.sTableId+'_first' );
					nPrevious.setAttribute( 'id', oSettings.sTableId+'_previous' );
					nNext.setAttribute( 'id', oSettings.sTableId+'_next' );
					nLast.setAttribute( 'id', oSettings.sTableId+'_last' );
				}
			},

			/*
			 * Function: oPagination.full_numbers.fnUpdate
			 * Purpose:  Update the list of page buttons shows
			 * Returns:  -
	 		 * Inputs:   object:oSettings - dataTables settings object
			 *           function:fnCallbackDraw - draw function to call on page change
			 */
			"fnUpdate": function ( oSettings, fnCallbackDraw )
			{
				if ( !oSettings.aanFeatures.p )
				{
					return;
				}

				var iPageCount = $.fn.dataTableExt.oPagination.iFullNumbersShowPages;
				var iPageCountHalf = Math.floor(iPageCount / 2);
				var iPages = Math.ceil((oSettings.fnRecordsDisplay()) / oSettings._iDisplayLength);
				var iCurrentPage = Math.ceil(oSettings._iDisplayStart / oSettings._iDisplayLength) + 1;
				var sList = "";
				var iStartButton, iEndButton, i, iLen;
				var oClasses = oSettings.oClasses;

				/* Pages calculation */
				if (iPages < iPageCount)
				{
					iStartButton = 1;
					iEndButton = iPages;
				}
				else
				{
					if (iCurrentPage <= iPageCountHalf)
					{
						iStartButton = 1;
						iEndButton = iPageCount;
					}
					else
					{
						if (iCurrentPage >= (iPages - iPageCountHalf))
						{
							iStartButton = iPages - iPageCount + 1;
							iEndButton = iPages;
						}
						else
						{
							iStartButton = iCurrentPage - Math.ceil(iPageCount / 2) + 1;
							iEndButton = iStartButton + iPageCount - 1;
						}
					}
				}

				/* Build the dynamic list */
                if(iStartButton>1) {
                    sList += '... ';
                }
				for ( i=iStartButton ; i<=iEndButton ; i++ )
				{
					if ( iCurrentPage != i )
					{
						sList += '<a href="#" class="'+oClasses.sPageButton+'">'+i+'</a> ';
					}
					else
					{
						sList += '<span class="'+oClasses.sPageButtonActive+'">'+i+'</span> ';
					}
				}
                if(iEndButton<iPages) {
                    sList += '...';
                }

				/* Loop over each instance of the pager */
				var an = oSettings.aanFeatures.p;
				var anButtons, nPaginateList;
				var fnClick = function() {
					/* Use the information in the element to jump to the required page */
                    //noinspection PointlessArithmeticExpressionJS
                    var iTarget = (this.innerHTML * 1) - 1;
					oSettings._iDisplayStart = iTarget * oSettings._iDisplayLength;
					fnCallbackDraw( oSettings );
					return false;
				};
				var fnFalse = function () { return false; };

				for ( i=0, iLen=an.length ; i<iLen ; i++ )
				{
					if ( an[i].childNodes.length === 0 )
					{
						continue;
					}

					/* Build up the dynamic list first - html and listeners */
					var qjPaginateList = $('.pages', an[i]);
					qjPaginateList.html( sList );
					$('.iterator-link', qjPaginateList).click( fnClick ).bind( 'mousedown', fnFalse )
						.bind( 'selectstart', fnFalse );

					/* Update the permanent botton's classes */
					anButtons = an[i].getElementsByTagName('a');
					var prevStatic = $([ anButtons[0], anButtons[1] ]),
						nextStatic = $([ anButtons[2], anButtons[3] ]);
					if ( iCurrentPage == 1 )
					{
						prevStatic.hide();
					}
					else
					{
						prevStatic.show();
					}

					if ( iPages === 0 || iCurrentPage == iPages || oSettings._iDisplayLength == -1 )
					{
						nextStatic.hide();
					}
					else
					{
						nextStatic.show();
					}
				}
			}
		}
	});
	//
	// Custom data types.
	//
    jQuery.fn.dataTableExt.aTypes = $.merge( [

		/*
		 * Replace existing numeric sorter with one that supports thousand separators. Not possible to have new a
         * 'formatted-numeric' data type because all values in a column must match the same data type - if some match
         * 'numeric' and some match 'formatted-numeric' then 'string' fallback is used.
         *
		 * Function: -
		 * Purpose:  Check to see if a string is numeric
		 * Returns:  string:'numeric' or null
		 * Inputs:   string:sText - string to check
		 */
		function ( sData )
		{
			/* Allow zero length strings as a number */
			if (sData== null || sData.length === 0 )
			{
				return 'numeric';
			}
			var sValidFirstChars = "0123456789-";
			var sValidChars = "0123456789.,";
			var Char;
			var bDecimal = false;

			/* Check for a valid first char (no period and allow negatives) */
			Char = sData.charAt(0);
			if (sValidFirstChars.indexOf(Char) == -1)
			{
				return null;
			}

			/* Check all the other characters are valid */
			for ( var i=1 ; i<sData.length ; i++ )
			{
				Char = sData.charAt(i);
				if (sValidChars.indexOf(Char) == -1)
				{
					return null;
				}

				/* Only allowed one decimal place... */
				if ( Char == "." )
				{
					if ( bDecimal )
					{
						return null;
					}
					bDecimal = true;
				}

				/* Separators not allowed after decimal place... */
				if ( Char == "," && bDecimal)
				{
						return null;
				}
			}
			return 'numeric';
		},
		function ( sData )
		{
            if(typeof sData.match != 'function') {
                return null;
            }
            var match = sData.match(/title=""/);
            if(match!=null) {
                return 'title-numeric';
            }
            match = sData.match(/title="(-?[0-9]+\.?[0-9]*)"/);
            if(match==null) {
                return null;
            }
            sData = match[1];

			var sValidFirstChars = "0123456789-";
			var sValidChars = "0123456789.,";
			var Char;
			var bDecimal = false;

			/* Check for a valid first char (no period and allow negatives) */
			Char = sData.charAt(0);
			if (sValidFirstChars.indexOf(Char) == -1)
			{
				return null;
			}

			/* Check all the other characters are valid */
			for ( var i=1 ; i<sData.length ; i++ )
			{
				Char = sData.charAt(i);
				if (sValidChars.indexOf(Char) == -1)
				{
					return null;
				}

				/* Only allowed one decimal place... */
				if ( Char == "." )
				{
					if ( bDecimal )
					{
						return null;
					}
					bDecimal = true;
				}
			}
			return 'title-numeric';
		},
		function ( sData )
		{
            if(typeof sData.match != 'function') {
                return null;
            }
            var match = sData.match(/title="(.*?)"/);
            if(match==null) {
                return null;
            }
			return 'title-string';
		}
	], jQuery.fn.dataTableExt.aTypes);

	//
	// Custom sorters
	//
    /* Replace existing numeric sorter with one that supports thousand separators */
    jQuery.fn.dataTableExt.oSort['numeric-asc'] = function(a, b)
    {
        var x = (a=="-" || a==="") ? null : isNaN(a) ? a.replace(/[^\d\-\.\/]/g, '') : a;
        var y = (b=="-" || b==="") ? null : isNaN(b) ? b.replace(/[^\d\-\.\/]/g, '') : b;
        // Always sort null after numbers
        if(x==null || y==null) return x==null ? y==null ? 0 : 1 : -1;
        //noinspection PointlessArithmeticExpressionJS
        return x / 1 - y / 1;
    };
    jQuery.fn.dataTableExt.oSort['numeric-desc'] = function(a, b)
    {
        var x = (a=="-" || a==="") ? null : isNaN(a) ? a.replace(/[^\d\-\.\/]/g, '') : a;
        var y = (b=="-" || b==="") ? null : isNaN(b) ? b.replace(/[^\d\-\.\/]/g, '') : b;
        // Always sort null after numbers
        if(x==null || y==null) return x==null ? y==null ? 0 : 1 : -1;
        //noinspection PointlessArithmeticExpressionJS
        return y / 1 - x / 1;
    };
    jQuery.fn.dataTableExt.oSort['title-numeric-asc']  = function(a,b) {
        var aMatch = a.match(/title="(-?[0-9]+\.?[0-9]*)"/);
        var bMatch = b.match(/title="(-?[0-9]+\.?[0-9]*)"/);
        // Always sort null after numbers
        if(aMatch==null || bMatch==null) return aMatch==null ? bMatch==null ? 0 : 1 : -1;
        var x = aMatch[1];
        var y = bMatch[1];
        x = parseFloat( x );
        y = parseFloat( y );
        return ((x < y) ? -1 : ((x > y) ?  1 : 0));
    };
    jQuery.fn.dataTableExt.oSort['title-numeric-desc'] = function(a,b) {
        var aMatch = a.match(/title="(-?[0-9]+\.?[0-9]*)"/);
        var bMatch = b.match(/title="(-?[0-9]+\.?[0-9]*)"/);
        // Always sort null after numbers
        if(aMatch==null || bMatch==null) return aMatch==null ? bMatch==null ? 0 : 1 : -1;
        var x = aMatch[1];
        var y = bMatch[1];
        x = parseFloat( x );
        y = parseFloat( y );
        return ((x < y) ?  1 : ((x > y) ? -1 : 0));
    };
    jQuery.fn.dataTableExt.oSort['title-string-asc']  = function(a,b) {
        var x = a.match(/title="(.*?)"/)[1].toLowerCase();
        var y = b.match(/title="(.*?)"/)[1].toLowerCase();
        return ((x < y) ? -1 : ((x > y) ?  1 : 0));
    };
    jQuery.fn.dataTableExt.oSort['title-string-desc'] = function(a,b) {
        var x = a.match(/title="(.*?)"/)[1].toLowerCase();
        var y = b.match(/title="(.*?)"/)[1].toLowerCase();
        return ((x < y) ?  1 : ((x > y) ? -1 : 0));
    };

    //
	// Custom search values
	//
    $.fn.dataTableExt.ofnSearch['numeric'] = function ( sData ) {
       return (sData=="-" || sData==="") ? 0 : isNaN(sData) ? sData.replace(/[^\d\-\.\/]/g, '') : sData;
    };
    $.fn.dataTableExt.ofnSearch['title-numeric'] = function ( sData ) {
        var match = sData.match(/title="(-?[0-9]+\.?[0-9]*)"/);
        return match==null ? '' : parseFloat(match[1]);
    };
    $.fn.dataTableExt.ofnSearch['title-string'] = function ( sData ) {
       return sData.match(/title="(.*?)"/)[1].toLowerCase();
    };

    /*
     * Function: fnGetColumnTitle
     * Purpose:  Return the title for a particular column.
     * Returns:  string:title
     * Inputs:   object:oSettings - dataTable settings object. This is always the last argument past to the function
     *           int:iColumn - the id of the column to extract the data from
     */
    $.fn.dataTableExt.oApi.fnGetColumnTitle = function ( oSettings, iColumn) {

        // check that we have a column id
        if ( typeof iColumn == "undefined" ) return null;

        return oSettings.aoColumns[iColumn].sTitle;
    };

    /*
     * Function: fnGetColumnData
     * Purpose:  Return an array of table values from a particular column.
     * Returns:  array string: 1d data array
     * Inputs:   object:oSettings - dataTable settings object. This is always the last argument past to the function
     *           int:iColumn - the id of the column to extract the data from
     *           bool:bUnique - optional - if set to false duplicated values are not filtered out
     *           bool:bFiltered - optional - if set to false all the table data is used (not only the filtered)
     *           bool:bIgnoreEmpty - optional - if set to false empty values are not filtered from the result array
     * Author:   Benedikt Forchhammer <b.forchhammer /AT\ mind2.de>
     */
    $.fn.dataTableExt.oApi.fnGetColumnData = function ( oSettings, iColumn, bUnique, bFiltered, bIgnoreEmpty, bSort ) {
        // check that we have a column id
        if ( typeof iColumn == "undefined" ) return new Array();

        // by default we only wany unique data
        if ( typeof bUnique == "undefined" ) bUnique = true;

        // by default we want all data, not just filtered
        if ( typeof bFiltered == "undefined" ) bFiltered = false;

        // by default we do not wany to include empty values
        if ( typeof bIgnoreEmpty == "undefined" ) bIgnoreEmpty = true;

        // by default we want to sort values
        if ( typeof bSort == "undefined" ) bSort = true;

        // list of rows which we're going to loop through
        var aiRows;

        // use only filtered rows
        if (bFiltered) aiRows = oSettings.aiDisplay;
        // use all rows
        else aiRows = oSettings.aiDisplayMaster; // all row numbers

        // set up data array
        var asResultData = new Array();

        for (var i=0,c=aiRows.length; i<c; i++) {
            var iRow = aiRows[i];
            var aData = this.fnGetData(iRow);
            var sValue = aData[iColumn];

            // ignore empty values?
            if (bIgnoreEmpty && sValue.length == 0) continue;

            // ignore unique values?
            else if (bUnique && jQuery.inArray(sValue, asResultData) > -1) continue;

            // else push the value onto the result data array
            else asResultData.push(sValue);
        }

        if(bSort) asResultData.sort();

        return asResultData;
    };

    //
    // Custom filters
    //
    $.fn.dataTableExt.afnFiltering.push(
        // Numeric range filter
        function( oSettings, aData, iDataIndex ) {

            var show = true;

            for ( var i=0 ; i<oSettings.aoPreSearchCols.length ; i++ )
			{
                var sSearch = oSettings.aoPreSearchCols[i].sSearch;
                // search string format e.g. ".*|1:100"
                // The ".*|" is to ensure this filter passes the default filter function.
                var match = sSearch.match(/\.\*\|(\d*\.?\d*):(\d*\.?\d*)/);
                if(match!=null) {
                    var sMin = match[1];
                    var sMax = match[2];
                    //noinspection PointlessArithmeticExpressionJS
                    var iMin = sMin*1;
                    //noinspection PointlessArithmeticExpressionJS
                    var iMax = sMax*1;
                    var sData;
                    if ( typeof $.fn.dataTableExt.ofnSearch[oSettings.aoColumns[i].sType] == "function" )
                    {

                        sData = $.fn.dataTableExt.ofnSearch[oSettings.aoColumns[i].sType]( aData[i] );
                    }
                    else {
                        sData = aData[i];
                    }
                    //noinspection PointlessArithmeticExpressionJS
                    var iData = sData*1;
                    if(sData==='' || isNaN(sData))
                    {
                        show = false;
                    }
                    else if(sMin != "" && iData < iMin) {
                        show = false;
                    }
                    else if(sMax != "" && iData > iMax) {
                        show = false;
                    }
                }
                if(!show) return show;
			}
            return show;
        },
        // html only filter (i.e. only show if contains html)
        function( oSettings, aData, iDataIndex ) {

            var show = true;

            for ( var i=0 ; i<oSettings.aoPreSearchCols.length ; i++ )
			{
                var sSearch = oSettings.aoPreSearchCols[i].sSearch;
                // search string format e.g. ".*|html-only"
                // The ".*|" is to ensure this filter passes the default filter function.
                var match = sSearch.match(/\.\*\|html\-only/);
                if(match!=null) {
                    if (aData[i].indexOf('<') == -1) {
                        show = false;
                    }
                }
                if(!show) return show;
			}
            return show;
        }
    );

    //
    // Init column filters
    //

    function initSelectFilters($datatable, oSettings)
    {
        $datatable.find("col.filter-select").each(function()
        {
            var columnIndex = $datatable.find("col").index($(this));
            var $filter = fnCreateSelectFilter($datatable.fnGetColumnData(columnIndex));

            addFilterToFooter($datatable, oSettings, columnIndex, $filter);

            var $select = $filter.children("select");
            if(oSettings.aoPreSearchCols[columnIndex].sSearch.length > 0)
            {
                $select.val(oSettings.aoPreSearchCols[columnIndex].sSearch);
            }
            $select.change(function()
            {
                $datatable.fnFilter($(this).val(), columnIndex);
            });
        });
    }

    function initInputFilters($datatable, oSettings)
    {
        $datatable.find("col.filter-input").each(function()
        {
            var columnIndex = $datatable.find("col").index($(this));
            var $filter = fnCreateInputFilter();

            addFilterToFooter($datatable, oSettings, columnIndex, $filter);
            var $input = $filter.children("input");
            var widthDiff = $input.outerWidth()-$input.width();
//            $input.width($input.closest('td').width()-widthDiff);
            var columnWidth = oSettings.aoColumns[columnIndex].sWidth;
            $input.width(columnWidth.substring(0, columnWidth.length-2)/1);

            if(oSettings.aoPreSearchCols[columnIndex].sSearch.length > 0)
            {
                $input.val(oSettings.aoPreSearchCols[columnIndex].sSearch);
            }
            $input.keyup(function()
            {
                $datatable.fnFilter($(this).val(), columnIndex);
            });
        });
    }

    function initNumericRangeFilters($datatable, oSettings)
    {
        $datatable.find("col.filter-numeric-range").each(function()
        {
            var columnIndex = $datatable.find("col").index($(this));
            var $filter = fnCreateNumericRangeFilter();

            addFilterToFooter($datatable, oSettings, columnIndex, $filter);
            var $input = $filter.children("input");
            var widthDiff = $input.outerWidth()-$input.width();
            var columnWidth = oSettings.aoColumns[columnIndex].sWidth;
            $input.width(columnWidth.substring(0, columnWidth.length-2)/2);

            if(oSettings.aoPreSearchCols[columnIndex].sSearch.length > 0)
            {
                var match = oSettings.aoPreSearchCols[columnIndex].sSearch.match(/\.\*\|(\d*\.?\d*):(\d*\.?\d*)/);
                $input.first().val(match[1]);
                $input.last().val(match[2]);
            }
            $input.keyup(function()
            {
                var min = $(this).parent().children("input").first().val();
                if(isNaN(min)) {min = '';}
                var max = $(this).parent().children("input").last().val();
                if(isNaN(max)) {max = '';}
                if(min || max) {
                    // The ".*|" is to ensure this filter passes the default filter function.
                    $datatable.fnFilter('.*|' + min + ':' + max, columnIndex,true);
                }
                else {
                    $datatable.fnFilter('', columnIndex);
                }
            });
        });
    }

    function initHtmlOnlyFilters($datatable, oSettings)
    {
        $datatable.find("col.filter-html-only").each(function()
        {
            var columnIndex = $datatable.find("col").index($(this));
            var $filter = fnCreateHtmlOnlyFilter($(this).dataset()['label']);

            addFilterToFooter($datatable, oSettings, columnIndex, $filter);
            var $input = $filter.children("input");

            if(oSettings.aoPreSearchCols[columnIndex].sSearch.length > 0)
            {
                $input.prop('checked', true);
            }
            $input.change(function()
            {
                if($input.is(':checked')) {
                    $datatable.fnFilter('.*|html-only', columnIndex,true);
                }
                else {
                    $datatable.fnFilter('', columnIndex);
                }
            });
        });
    }
    
    function addFilterToFooter($datatable, oSettings, columnIndex, $filter)
    {
        var $footerCell = $datatable.find("tfoot tr.filters td:eq(" + columnIndex + ")");
        if($footerCell.size() == 0)
        {
            var $tfoot = $datatable.find('tfoot');
            if($tfoot.size()==0) {
                $tfoot = $("<tfoot />").appendTo($datatable);
            }
            var $footerRow = $("<tr />").addClass("filters");
            var columnCount = $datatable.find("col").size();
            for(var i = 0; i < columnCount; i++)
            {
                $footerRow.append($("<td />").html("&nbsp;"));
            }

            $tfoot.append($footerRow);
            $footerCell = $datatable.find("tfoot tr.filters td:eq(" + columnIndex + ")");
        }
        $footerCell.html($filter);
    }

    function addAggregateToFooter($datatable, oSettings, columnIndex, value)
    {
        var $footerCell = $datatable.find("tfoot tr.aggregates td:eq(" + columnIndex + ")");
        if($footerCell.size() == 0)
        {
            var $tfoot = $datatable.find('tfoot');
            if($tfoot.size()==0) {
                $tfoot = $("<tfoot />").prependTo($datatable);
            }
            var $footerRow = $("<tr />").addClass("aggregates");
            var columnCount = $datatable.find("col").size();
            for(var i = 0; i < columnCount; i++)
            {
                $footerRow.append($("<td />").addClass("number").html("&nbsp;"));
            }

            $tfoot.append($footerRow);
            $footerCell = $datatable.find("tfoot tr.aggregates td:eq(" + columnIndex + ")");
        }
        $footerCell.html(value);
    }

    function fnCreateSelectFilter(aData, label)
    {
        var select = $('<select />').html($("<option />").attr("value", ""));
        for(var i = 0; i < aData.length; i++)
        {
            var data = aData[i];
            if (data.match(/\s*\<.+\>\s*/)) {
                var $data = $(data);
                if ($data.filter('[title]').size() > 0) {
                    // Create an empty div to use as a container,
                    // then put the raw text in and get the HTML
                    // equivalent out.
                    data = jQuery('<div/>').text($data.filter('[title]').attr('title')).html();
                }
            }
            select.append($("<option />").attr("value", data).html(data));
        }
        var div = $("<div />");
        if(label) {
            div.prepend(": ").prepend(label);
        }
        return div.append(select);
    }

    function fnCreateInputFilter(label)
    {
        var div = $('<div><input type="text" /></div>');
        if(label) {
            div.prepend(": ").prepend(label);
        }
        return div;
    }

    function fnCreateNumericRangeFilter(label)
    {
        var div = $('<div><input type="text" placeholder="min" />:<input type="text" placeholder="max" /></div>');
        if(label) {
            div.prepend(": ").prepend(label);
        }
        return div;
    }

    function fnCreateHtmlOnlyFilter(label)
    {
        var div = $('<div><input type="checkbox" value="true" /></div>');
        if(label) {
            div.append(label);
        }
        return div;
    }

    function initLanguageDataTableUrl(initPluginCallback) {
        var langCountryCode = $('html').data('lang-js');
        var langCode = langCountryCode.split('-')[0];
        var langCountryUrl = createLanguageDataTableUrl(langCountryCode);
        var langUrl = createLanguageDataTableUrl(langCode);
        var englishUrl = createLanguageDataTableUrl('en');

        languageDataTableFileExists(
            langCountryUrl,
			function() { initPluginCallback(langCountryUrl); },
			function() {
        		languageDataTableFileExists(
                    langUrl,
					function() { initPluginCallback(langUrl); },
					function() { initPluginCallback(englishUrl); });
        	});
    }

    function createLanguageDataTableUrl(langCode) {
        return staticJavaScriptUrl('/jquery/i18n/jquery.dataTables-' + langCode + '.json');
    }

    function languageDataTableFileExists(langUrl, successCallback, failCallback) {
		$.ajax({
            url: langUrl,
            type: 'HEAD',
            cache: true,
			supressErrorDialog: true,
			success: successCallback,
			error: failCallback
        });
    }

})(jQuery);